import useOffersStuff from './useOffersStuff';
import { OfferTypeEnum } from '../../../services/exports/Constants';
import useGetMenuOfferHandlerByKind from './get-offer-handler/useGetMenuOfferHandlerByKind';

const useBogoItemOffer = () => {
  const { unlockedOffers } = useOffersStuff();
  const bogoOffer = unlockedOffers?.find((offer) => offer.type === OfferTypeEnum.Bogo);
  const productOfferStuff = useGetMenuOfferHandlerByKind()(bogoOffer);

  return {
    offer: bogoOffer,
    ...productOfferStuff,
  };
};

export default useBogoItemOffer;
